import { Reducer } from 'redux';
import { IAction } from '../types';
import LocalStore from '../../utils/store';

export interface ShopCartConfState {
  shop_cart_title: string;
  shop_cart_content: string;
  shop_cart_count: number;
  cart_add_max_num: number;
  auth_status: number;
  trade_coin: number;
  wx_shield: number;
  user_total_cart_count: number;
}

const SHOPCARTCONF_KEY = 'React-ts-ant-shopCartConf';

const localShopCartConfs = LocalStore.getValue<ShopCartConfState>(SHOPCARTCONF_KEY) || {};

export const defaults: ShopCartConfState = {
  shop_cart_title: '',
  shop_cart_content: '',
  shop_cart_count: 0,
  cart_add_max_num: 0,
  auth_status: 0,
  trade_coin: 0,
  wx_shield: 0,
  user_total_cart_count: 0,
  ...localShopCartConfs
};

const SHOP_CARTCONF_KEY = 'React-ts-ant-SHOPCARTCONF';

export const updateShopCartConfs: (homeNewSuits: ShopCartConfState) => IAction<ShopCartConfState> = (
  homeNewSuits: ShopCartConfState
) => ({
  type: SHOP_CARTCONF_KEY,
  payload: homeNewSuits
});

const shopCartConfReducer: Reducer<ShopCartConfState, IAction<any>> = (state = defaults, action: IAction<any>) => {
  const { type, payload } = action;

  switch (type) {
    case SHOP_CARTCONF_KEY:
      LocalStore.setValue(SHOPCARTCONF_KEY, payload as ShopCartConfState);
      return {
        ...payload
      };
    default:
      return {
        ...state
      };
  }
};

export default shopCartConfReducer;
